import {IconButton, styled} from "@mui/material";
import DescriptionIcon from '@mui/icons-material/Description';
export const FileListContainer = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  overflow: auto;
  
  gap: 16px;
  padding: 16px 0;
  height: 150px;

  margin: 0 25px 0 25px;
`;

export const FileIcon = styled(DescriptionIcon)`
  width: 70px;
  height: 70px;
  color: #F57B20;
`;

export const FileElement = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 90px;
  height: 100px;
  border: 1px solid transparent;
  padding: 4px;
  
  &:hover {
    border: 1px solid #F57B20;
  }
  border-radius: 10px;
`;

export const FileName = styled('div')`
  width: 100%;
  text-overflow: ellipsis;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
`;

export const CloseIconContainer = styled('div')`
  position: absolute;
  top: 0px;
  right: 0px;
`;

export const CloseIconButton = styled(IconButton)`
  width: 24px;
  height: 24px;
  cursor: pointer;

`;
